module.exports = __webpack_public_path__ + "img/MarinaRiviera_Full_GREEN.2154614f.png";